import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { getobj } from "../apicall/apicall";
import Table from "@mui/material/Table";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { timeStamp } from "../apicall/commonFunction";
import { new_format, cellular_device } from "../apicall/map";
import { Pagination } from "@mui/material";

export default function MeasuredData(props) {
  const [telemetry, settelemetry] = useState();
  const [load, setload] = useState(false);
  const [loaded, setloaded] = useState(true);
  const [page, setpage] = useState(1);
  const [totalpage, setpaget] = useState();

  const handlePagechange = (event, value) => {
    setpage(value);
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "device/telemetry/" +
      props.id +
      "/?page=" +
      value;
    const d = getobj(url);
    d.then(function (res) {
      settelemetry(res.results);
    });
  };

  useEffect(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "device/telemetry/" +
      props.id +
      "/?page=1";
    const d = getobj(url);
    d.then(function (res) {
      if (res.results.length > 0) {
        setload(true);
      }
      settelemetry(res.results);
      if (res.count % 5 > 0) {
        setpaget(Math.floor(res.count / 5) + 1);
      } else {
        setpaget(Math.floor(res.count / 5));
      }

      setloaded(false);
    });
  }, [props.refresh, props.id]);
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  return (
    <div>
      {loaded ? (
        <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt="loading..."/>
      ) : load ? (
        <Box>
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    <b>Date</b>
                  </StyledTableCell>

                  <StyledTableCell>
                    <b>Data</b>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {telemetry &&
                  telemetry.map((tel) => (
                    <StyledTableRow key={tel.id}>
                      <StyledTableCell>
                        {tel.measured_data &&
                        Object.keys(tel.measured_data).includes("imei")
                          ? timeStamp(parseInt(tel.utc, 16))
                          : Object.keys(tel.measured_data).includes("la")
                          ? timeStamp(tel.utc).split(",")[0] +
                            ", " +
                            timeStamp(tel.utc).split(",")[1]
                          : timeStamp(tel.utc)}
                      </StyledTableCell>
                      <StyledTableCell>
                        {tel.measured_data &&
                        Object.keys(tel.measured_data).includes("imei") ? (
                          <div>
                            {Object.keys(
                              cellular_device[tel.measured_data["type"]]
                            ).map((i) => {
                              return (
                                <div>
                                  {cellular_device[tel.name][i] +
                                    ":" +
                                    tel.measured_data.tel[i]}
                                  <br />
                                </div>
                              );
                            })}
                          </div>
                        ) : tel.measured_data.tel ? (
                          Object.keys(new_format[tel.name]).map((i) => {
                            //console.log(new_format[tel.name][i])
                            return (
                              <div>
                                {new_format[tel.name][i] +
                                  ":" +
                                  tel.measured_data.tel[i]}
                                <br />
                              </div>
                            );
                          })
                        ) : (
                          "Old format"
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <h6 style={{ fontFamily: "Roboto" }}>No Data available</h6>
      )}
      {/* {load ? (
        loaded ? (
          <img src="https://zewa-logo-bucket.s3.us-west-2.amazonaws.com/logo/Spinner-1s-200px.gif" />
        ) : (
          <Box>
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>
                      <b>Date</b>
                    </StyledTableCell>

                    <StyledTableCell>
                      <b>Data</b>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {telemetry &&
                    telemetry.map((tel) => (
                      <StyledTableRow key={tel.id}>
                        <StyledTableCell>
                          {tel.measured_data &&
                          Object.keys(tel.measured_data).includes("imei")
                            ? timeStamp(parseInt(tel.utc, 16))
                            : timeStamp(tel.utc)}
                        </StyledTableCell>
                        <StyledTableCell>
                          {tel.measured_data &&
                          Object.keys(tel.measured_data).includes("imei") ? (
                            <div>
                              {"Systolic blood pressure: " +
                                tel.measured_data.sys}
                              <br />
                              {"Diastolic blood pressure: " +
                                tel.measured_data["dia"]}{" "}
                              <br />
                              {"Pulse (Heart Rate): " +
                                tel.measured_data["pul"]}{" "}
                              <br />
                              {"Irregular heart beat: " +
                                tel.measured_data["ihb"]}
                              <br />
                              {"User ID: " + tel.measured_data.user}
                            </div>
                          ) : tel.measured_data.tel ? (
                            
                            Object.keys(new_format[tel.name]).map((i) => {
                              console.log(new_format[tel.name][i])
                              return (
                                <div>
                                  {new_format[tel.name][i] +
                                    ":" +
                                    tel.measured_data.tel[i]}
                                  <br />
                                </div>
                              );
                            })
                          ) : (
                            "Old format"
                          )}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )
      ) : (
        <h6 style={{ fontFamily: "Roboto" }}>No Data available</h6>
      )} */}
      <Pagination
        count={totalpage}
        variant="outlined"
        color="primary"
        onChange={handlePagechange}
      />
    </div>
  );
}

// {
//   (
//     JSON.stringify(tel.measured_data.tel)
//       .slice(1, -1)
//       .split(",")
//       .map((i) => {
//         return (
//           <div>
//             {ld[i.split(":")[0].slice(1,-1)]+" : "+i.split(":")[1].slice(0.4)}
//             <br />
//           </div>
//         );
//       })
//   )
// }
